export const NumberRecords = ({ value }) => {
  return (
    <div className="flex items-center gap-1">
      <span className="text-base-1000 font-medium text-[16px]/[24px]">
        {value}
      </span>
      <span className="text-base-1000 text-[16px]/[24px]">records</span>
    </div>
  );
};
